import React from 'react';
import { Sparkles, LogOut } from 'lucide-react';
import { useUser } from './UserManagement';

/**
 * 对外演示模式顶栏：提示数据为真实环境、建议勿改动；退出即清除会话。
 */
export default function DemoModeBanner() {
  const { logout, user } = useUser();

  const exit = () => {
    try {
      sessionStorage.removeItem('audit_portal_demo_error');
    } catch (_) {}
    logout();
    const u = new URL(window.location.href);
    u.searchParams.delete('demo');
    window.history.replaceState({}, '', u.pathname + u.search + u.hash);
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9998] flex flex-wrap items-center justify-center gap-x-4 gap-y-2 px-4 py-2 text-sm text-amber-950 bg-gradient-to-r from-amber-200 via-amber-100 to-amber-200 border-b border-amber-300/80 shadow-sm"
      role="status"
    >
      <span className="inline-flex items-center gap-2 font-medium">
        <Sparkles className="w-4 h-4 shrink-0 text-amber-700" aria-hidden />
        演示模式
      </span>
      <span className="text-amber-900/90">
        当前以「{user?.name || user?.username || '访客'}」浏览功能模块；数据来自当前环境，对外展示后建议关闭演示入口（ALLOW_PUBLIC_DEMO）。
      </span>
      <button
        type="button"
        onClick={exit}
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-amber-900/90 text-amber-50 hover:bg-amber-950 text-xs font-medium transition-colors"
      >
        <LogOut className="w-3.5 h-3.5" />
        退出演示
      </button>
      <span className="hidden sm:inline text-xs text-amber-800/90">正式环境请使用管理员分配的账号登录</span>
    </div>
  );
}
